 // Script para activar automáticamente el toggle de protección de envío
 document.addEventListener('DOMContentLoaded', function() {
  console.log('Toggle Activator v3.0: Iniciando...');
 
  // Configuración
  const config = {
    retryDelay: 300,           // Tiempo base entre reintentos (ms)
    maxRetryDelay: 3000,       // Tiempo máximo entre reintentos (ms)
    maxAttempts: 30,           // Número máximo de intentos
    initialDelay: 200,         // Espera inicial después de añadir al carrito (reducido para activación más rápida)
    observerThrottle: 100,     // Tiempo mínimo entre activaciones del observer (ms)
    cartAddedPriority: true    // Priorizar activación cuando se añade al carrito
  };
 
  // Estado global
  const state = {
    lastToggleActivation: 0,   // Timestamp del último intento de activación
    cartDrawerVisible: false,  // Si el cajón del carrito está visible
    toggleActivated: false,    // Si el toggle ya ha sido activado en esta sesión
    pendingActivation: false,  // Si hay una activación pendiente
    cartJustAdded: false,      // Si se acaba de añadir algo al carrito
    lastCartAddTime: 0         // Timestamp de la última adición al carrito
  };
 
  // Función para encontrar el elemento del carrito y activar el toggle
  function findCartAndActivateToggle() {
   
    // Lista de posibles selectores para el carrito
    const cartSelectors = [
      '#upCart', 
      '#upcart', 
      '#cart-drawer', 
      '[id*="cart"]', 
      '[id*="Cart"]', 
      'upcart-drawer', 
      'cart-drawer',
      // Selectores adicionales basados en atributos comunes
      '[data-cart]',
      '[data-cart-drawer]',
      '[data-upcart]',
      '[aria-label*="cart"]',
      '[aria-label*="Cart"]'
    ];
   
    let cartElement = null;
   
    // Buscar el elemento del carrito
    for (const selector of cartSelectors) {
      try {
        const elements = document.querySelectorAll(selector);
       
        for (const el of elements) {
          // Verificar si el elemento tiene shadowRoot
          if (el && el.shadowRoot) {
            cartElement = el;
            break;
          }
         
          // Verificar si el elemento está visible (podría contener el toggle directamente)
          if (el && isElementVisible(el)) {
            if (findToggleInElement(el)) {
              return true;
            }
          }
        }
       
        if (cartElement) break;
      } catch (e) {
      }
    }
   
    // Si no encontramos con los selectores específicos, buscar cualquier elemento con shadowRoot
    if (!cartElement) {
     
      // Primero buscar en elementos que probablemente sean el carrito
      const cartKeywords = ['cart', 'basket', 'upcart', 'drawer'];
      const potentialCartElements = Array.from(document.querySelectorAll('*')).filter(el => {
        const id = (el.id || '').toLowerCase();
        const className = (el.className || '').toLowerCase();
        return cartKeywords.some(keyword => id.includes(keyword) || className.includes(keyword));
      });
     
      for (const el of potentialCartElements) {
        if (el.shadowRoot) {
          cartElement = el;
          break;
        }
      }
     
      // Si aún no encontramos, buscar en todos los elementos
      if (!cartElement) {
        const allElements = document.querySelectorAll('*');
        for (const el of allElements) {
          if (el.shadowRoot) {
            cartElement = el;
            break;
          }
        }
      }
     }
   
    if (!cartElement) {
      return false;
    }
   
    // Activar el toggle dentro del shadow DOM
    return activateToggleInShadow(cartElement.shadowRoot);
  }
 
  // Función para verificar si un elemento es visible
  function isElementVisible(el) {
    if (!el) return false;
   
    const style = window.getComputedStyle(el);
    return style.display !== 'none' && 
           style.visibility !== 'hidden' && 
           style.opacity !== '0' &&
           el.offsetWidth > 0 && 
           el.offsetHeight > 0;
  }
 
  // Función para buscar el toggle directamente en un elemento (sin shadowRoot)
  function findToggleInElement(element) {
    const toggleSelectors = getToggleSelectors();
   
    for (const selector of toggleSelectors) {
      try {
        const toggles = element.querySelectorAll(selector);
        for (const toggle of toggles) {
          if (isElementVisible(toggle)) {
           
            if (activateToggleElement(toggle)) {
              return true;
            }
          }
        }
      } catch (e) {
        console.error(`Toggle Activator: Error al buscar toggle con selector ${selector}:`, e);
      }
    }
   
    return false;
  }
 
  // Función para obtener todos los selectores de toggle
// Función para obtener todos los selectores de toggle
function getToggleSelectors() {
   return [
     // UpCart: estructura (label.toggle-switch > input + span.slider)
     'label.upcart-internal-addons__toggle-switch.upcart-public-addons__toggle-switch input[type="checkbox"]',
     'label.upcart-internal-addons__toggle-switch.upcart-public-addons__toggle-switch',
     '.upcart-internal-addons__toggle-switch input[type="checkbox"]',
     '.upcart-public-addons__toggle-switch input[type="checkbox"]',
     '.upcart-internal-addons__toggle-slider',
     '.upcart-public-addons__toggle-slider',
     '.upcart-internal-addons__toggle.upcart-public-addons__toggle input[type="checkbox"]',
 
     // Selectores específicos previos (legacy)
     '.styles_AddonsModule__toggle__ .styles_ToggleSwitch__',
     '.upcart-addons-toggle .styles_ToggleSwitch__',
     '.Stack__item .styles_ToggleSwitch__',
     '.styles_AddonsModule__ .styles_ToggleSwitch__',
     '.Stack .Stack__item .styles_AddonsModule__toggle__ .styles_ToggleSwitch__',
 
     // Basados en texto o etiquetas
     // Generales
     '.styles_ToggleSwitch__',
     '[class*="ToggleSwitch"]',
     '[role="switch"]',
     'input[type="checkbox"]'
   ];
 }
 
  // Función para activar un elemento toggle específico
// Función para activar un elemento toggle específico
function activateToggleElement(toggle) {
   if (!toggle) return false;
 
   try {
     // Normalizar: localizar el input checkbox asociado
     let input = null;
 
     if (toggle.tagName === 'INPUT' && toggle.type === 'checkbox') {
       input = toggle;
     } else if (toggle.tagName === 'LABEL') {
       input = toggle.querySelector('input[type="checkbox"]');
     } else if (toggle.tagName === 'SPAN') {
       const label = toggle.closest('label');
       if (label) input = label.querySelector('input[type="checkbox"]');
     } else if (toggle.querySelector) {
       input = toggle.querySelector('input[type="checkbox"]');
     }
 
     // Determinar estado activo
     const ariaChecked = (input || toggle).getAttribute && (input || toggle).getAttribute('aria-checked');
     const isChecked = !!(input && input.checked);
     const hasActiveClass = !!(toggle.classList && (toggle.classList.contains('styles_ToggleSwitch--active__') || toggle.classList.contains('active')));
     const isActive = hasActiveClass || ariaChecked === 'true' || isChecked;
 
     if (!isActive) {
       // Preferir click en el input; si no existe, click en el elemento encontrado
       if (input) {
         input.click();
       } else {
         toggle.click();
       }
       state.toggleActivated = true;
       return true;
     }
 
     state.toggleActivated = true;
     return true;
   } catch (e) {
     console.error('Toggle Activator: Error al activar toggle:', e);
     return false;
   }
 }
 
  // Función para activar el toggle dentro del shadow DOM
  function activateToggleInShadow(shadowRoot, depth = 0) {
    if (!shadowRoot || depth > 10) return false;
   
    // Obtener selectores de toggle
    const toggleSelectors = getToggleSelectors();
   
    // Intentar encontrar el toggle con cada selector
    for (const selector of toggleSelectors) {
      try {
        const toggles = shadowRoot.querySelectorAll(selector);
        for (const toggle of toggles) {
          if (isElementVisible(toggle)) {
           
            if (activateToggleElement(toggle)) {
              return true;
            }
          }
        }
      } catch (e) {
        console.error(`Toggle Activator: Error al buscar toggle con selector ${selector}:`, e);
      }
    }
   
    // Si no encontramos el toggle, buscar en todos los shadow DOMs anidados
    try {
      const elements = shadowRoot.querySelectorAll('*');
     
      // Primero buscar en elementos que parezcan relacionados con addons o protección
      const keywordElements = Array.from(elements).filter(el => {
        const className = (el.className || '').toLowerCase();
        const id = (el.id || '').toLowerCase();
        const text = (el.textContent || '').toLowerCase();
       
        return className.includes('addon') || 
               className.includes('protection') || 
               id.includes('addon') || 
               id.includes('protection') ||
               text.includes('shipping protection');
      });
     
      // Buscar primero en elementos con palabras clave
      for (const el of keywordElements) {
        if (el.shadowRoot) {
          if (activateToggleInShadow(el.shadowRoot, depth + 1)) {
            return true;
          }
        }
      }
     
      // Luego buscar en todos los demás elementos
      for (let i = 0; i < elements.length; i++) {
        const el = elements[i];
        if (el.shadowRoot && !keywordElements.includes(el)) {
          if (activateToggleInShadow(el.shadowRoot, depth + 1)) {
            return true;
          }
        }
      }
    } catch (e) {
      console.error('Toggle Activator: Error al buscar en shadow DOMs anidados:', e);
    }
   
    return false;
  }
 
  // Función para intentar activar el toggle con backoff exponencial
  function attemptActivation(attempts = 0, isCartAddEvent = false) {
    if (state.toggleActivated && !isCartAddEvent) {
      return;
    }
   
    // Si es un evento de añadir al carrito, siempre intentamos activar el toggle
    // incluso si ya se activó antes, para asegurar que esté activo después de cada adición
    if (isCartAddEvent) {
      state.toggleActivated = false;
      state.cartJustAdded = true;
      state.lastCartAddTime = Date.now();
    }
   
    if (attempts >= config.maxAttempts) {
      console.warn(`Toggle Activator: No se pudo activar el toggle después de ${config.maxAttempts} intentos`);
      return;
    }
   
    // Evitar activaciones demasiado frecuentes
    const now = Date.now();
    if (now - state.lastToggleActivation < 100) {
      return;
    }
    state.lastToggleActivation = now;
   
    const success = findCartAndActivateToggle();
   
    if (!success) {
      // Backoff exponencial con límite máximo
      // Si es un evento de añadir al carrito, usar retrasos más cortos
      let delay = Math.min(config.retryDelay * Math.pow(1.5, attempts), config.maxRetryDelay);
      if (isCartAddEvent || state.cartJustAdded) {
        delay = Math.min(delay, 500); // Retrasos más cortos para eventos de carrito
      }
     
     
      state.pendingActivation = true;
      setTimeout(() => {
        state.pendingActivation = false;
        // Mantener la bandera de cartJustAdded durante los primeros intentos
        const stillCartEvent = state.cartJustAdded && (attempts < 5);
        attemptActivation(attempts + 1, stillCartEvent);
      }, delay);
    } else {
      state.cartJustAdded = false;
    }
  }
 
  // Configurar observador de mutaciones para detectar cuando aparece el carrito
  function setupMutationObserver() {
   
    let lastObserverActivation = 0;
   
    const observer = new MutationObserver((mutations) => {
      // Limitar la frecuencia de activación del observer
      const now = Date.now();
      if (now - lastObserverActivation < config.observerThrottle) return;
      lastObserverActivation = now;
     
      // Buscar cambios que puedan indicar que el carrito se ha abierto
      const cartOpened = mutations.some(mutation => {
        // Buscar elementos añadidos que puedan ser el carrito
        if (mutation.addedNodes.length > 0) {
          for (const node of mutation.addedNodes) {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const el = node;
              const id = (el.id || '').toLowerCase();
              const className = (el.className || '').toLowerCase();
             
              if (id.includes('cart') || className.includes('cart') || 
                  id.includes('drawer') || className.includes('drawer')) {
                return true;
              }
            }
          }
        }
       
        // Buscar cambios de atributos que puedan indicar que el carrito se ha abierto
        if (mutation.type === 'attributes') {
          const target = mutation.target;
          if (target.nodeType === Node.ELEMENT_NODE) {
            const id = (target.id || '').toLowerCase();
            const className = (target.className || '').toLowerCase();
           
            if ((id.includes('cart') || className.includes('cart')) && 
                (mutation.attributeName === 'class' || mutation.attributeName === 'style')) {
              return true;
            }
          }
        }
       
        return false;
      });
     
      // Verificar si se acaba de añadir algo al carrito recientemente
      const cartJustAdded = state.cartJustAdded || (Date.now() - state.lastCartAddTime < 3000);
     
      if (cartOpened && !state.pendingActivation) {
        // Si se acaba de añadir algo al carrito, activar con prioridad
        setTimeout(() => attemptActivation(0, cartJustAdded), cartJustAdded ? 200 : 500);
      }
    });
   
    // Observar todo el documento para detectar cambios
    observer.observe(document.body, { 
      childList: true, 
      subtree: true, 
      attributes: true,
      attributeFilter: ['class', 'style'] 
    });
  }
 
  // Suscribirse al evento de añadir al carrito
  function setupCartListener() {
    // Intentar usar la API específica de upcart
    if (typeof window.upcartSubscribeAddedToCart === 'function') {
      try {
        window.upcartSubscribeAddedToCart(({ item }) => {
         
          // Activar inmediatamente cuando se añade al carrito
          // Pasamos true para indicar que es un evento de añadir al carrito
          setTimeout(() => attemptActivation(0, true), config.initialDelay);
        });
      } catch (error) {
        console.error('Toggle Activator: Error al suscribirse a eventos del carrito:', error);
        setupFallbackListeners();
      }
    } else {
      setupFallbackListeners();
     
      // Seguir intentando suscribirse a upcartSubscribeAddedToCart
      setTimeout(() => {
        if (typeof window.upcartSubscribeAddedToCart === 'function') {
          try {
            window.upcartSubscribeAddedToCart(({ item }) => {
              setTimeout(() => attemptActivation(0, true), config.initialDelay);
            });
          } catch (error) {
            console.error('Toggle Activator: Error al suscribirse a eventos del carrito:', error);
          }
        }
      }, 3000);
    }
  }
 
  // Configurar listeners alternativos para detectar interacciones con el carrito
  function setupFallbackListeners() {
   
    // Escuchar eventos de clic en botones de "Añadir al carrito"
    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!target) return;

      const textContent = (target.textContent || '').toLowerCase();
      const nameAttr = (target.getAttribute && target.getAttribute('name')) ? target.getAttribute('name').toLowerCase() : '';
      const idAttr = (target.getAttribute && target.getAttribute('id')) ? target.getAttribute('id').toLowerCase() : '';
      const isAddToCartButton = 
        (target.tagName === 'BUTTON' || target.tagName === 'A') && 
        (textContent.includes('add to cart') || 
         textContent.includes('añadir al carrito') ||
         (target.classList && target.classList.contains('add-to-cart')) ||
         (target.closest && target.closest('.add-to-cart')) ||
         nameAttr.includes('add') ||
         idAttr.includes('add-to-cart'));

      if (isAddToCartButton) {
        setTimeout(() => attemptActivation(0, true), config.initialDelay);
      }
    });
   // Interceptar formularios de añadir al carrito
   document.addEventListener('submit', (event) => {
     const form = event.target;
     if (form && form.action && 
         (form.action.includes('/cart/add') || 
          form.getAttribute('data-cart-submit') || 
          form.classList.contains('product-form'))) {
       setTimeout(() => attemptActivation(0, true), config.initialDelay);
     }
   });
   
   // Escuchar eventos de fetch/XHR para detectar actualizaciones del carrito
    const originalFetch = window.fetch;
    window.fetch = function(url, options) {
      const promise = originalFetch.apply(this, arguments);
     
      if (url && typeof url === 'string') {
        // Detectar específicamente adiciones al carrito
        if (url.includes('/cart/add')) {
          promise.then(() => {
            setTimeout(() => attemptActivation(0, true), config.initialDelay);
          });
        }
        // Otras operaciones del carrito
        else if (url.includes('/cart/update') || url.includes('/cart/change')) {
          promise.then(() => {
            setTimeout(() => attemptActivation(0, true), config.initialDelay);
          });
        }
      }
     
      return promise;
    };
   
   // Interceptar XMLHttpRequest para detectar operaciones del carrito
   const originalOpen = XMLHttpRequest.prototype.open;
   XMLHttpRequest.prototype.open = function(method, url) {
     if (url && typeof url === 'string' && url.includes('/cart/add')) {
       this.addEventListener('load', function() {
         setTimeout(() => attemptActivation(0, true), config.initialDelay);
       });
     }
     return originalOpen.apply(this, arguments);
   };
   
   // Escuchar eventos personalizados de Shopify
   document.addEventListener('theme:cart:change', () => {
     setTimeout(() => attemptActivation(0, true), config.initialDelay);
   });
   
   document.addEventListener('cart:refresh', () => {
     setTimeout(() => attemptActivation(0, true), config.initialDelay);
   });
   
   // Eventos adicionales específicos de Shopify
   document.addEventListener('product:added', () => {
     setTimeout(() => attemptActivation(0, true), config.initialDelay);
   });
   
   document.addEventListener('cart:updated', () => {
     setTimeout(() => attemptActivation(0, true), config.initialDelay);
   });
   
   // Escuchar cambios en la URL para detectar páginas de carrito
   let lastUrl = window.location.href;
   setInterval(() => {
     if (window.location.href !== lastUrl) {
       lastUrl = window.location.href;
       if (lastUrl.includes('/cart')) {
          setTimeout(() => attemptActivation(0, true), config.initialDelay);
       }
     }
   }, 1000);
 
  // Iniciar el proceso
  console.log('Toggle Activator: Iniciando configuración...');
  setupMutationObserver();
  setTimeout(() => {
    setupCartListener();
    attemptActivation();
  }, 500); // Reducido para iniciar más rápido
 
  // Intentar activar el toggle periódicamente durante los primeros 30 segundos
  let periodicAttempts = 0;
  const periodicInterval = setInterval(() => {
    if (periodicAttempts >= 10 || (state.toggleActivated && !state.cartJustAdded)) {
      clearInterval(periodicInterval);
      return;
    }
    // Si se acaba de añadir algo al carrito, intentar con prioridad
    const cartJustAdded = state.cartJustAdded || (Date.now() - state.lastCartAddTime < 3000);
    attemptActivation(0, cartJustAdded);
    periodicAttempts++;
  }, 2000); // Reducido para intentos más frecuentes
 
  // Escuchar eventos de botones de añadir al carrito inmediatamente
  document.querySelectorAll('button[name*="add"], button.add-to-cart, a.add-to-cart, [data-add-to-cart]').forEach(button => {
    button.addEventListener('click', () => {
      setTimeout(() => attemptActivation(0, true), config.initialDelay);
    });
  });
 }
});



  
